import React from 'react';
import { createUseStyles } from 'react-jss';

import Star from './star';

const useStyles = createUseStyles({
  stars: {
    composes: ['is-absolute'],
    height: 80,
    left: '50%',
    marginLeft: -70,
    top: -20,
    width: 60,
    zIndex: 1,
  },
});

const StarsComponent = React.memo(() => {
  const classes = useStyles();

  return (
    <div className={classes.stars}>
      <div className={classes.wrapper}>
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
      </div>
    </div>
  );
});

StarsComponent.displayName = 'StarsComponent';

export default StarsComponent;
